import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/shared/ui/dialog';
import { Button } from '@/shared/ui/button';
import { Input } from '@/shared/ui/input';
import { Label } from '@/shared/ui/label';

export interface AddNewCostCodeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  searchValue: string;
  onConfirm: (value: string) => void;
}

export const AddNewCostCodeDialog: React.FC<AddNewCostCodeDialogProps> = ({
  open,
  onOpenChange,
  searchValue,
  onConfirm,
}) => {
  const [code, setCode] = useState('');
  const [name, setName] = useState(searchValue);

  React.useEffect(() => {
    if (open) {
      setName(searchValue);
      setCode('');
    }
  }, [open, searchValue]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (code.trim() && name.trim())
      onConfirm(JSON.stringify({ code: code.trim(), name: name.trim() }));
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>New Cost Code</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 pt-1">
          <div className="space-y-1">
            <Label htmlFor="new-costcode-code">Code</Label>
            <Input
              id="new-costcode-code"
              placeholder="e.g. 03-200"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              autoFocus
            />
          </div>
          <div className="space-y-1">
            <Label htmlFor="new-costcode-name">Name</Label>
            <Input
              id="new-costcode-name"
              placeholder="e.g. Concrete Reinforcing"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button type="submit" disabled={!code.trim() || !name.trim()}>
              Create
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
